import React, { Component } from 'react';
import { connect } from 'react-redux';

class RequestAdjustedTermsDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            termsText: '',
            errorMessage: ''
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.handleDialog('RequestAdjustedTermsDialog');
    }
    componentWillMount() {
        this.setState({
            termsText: this.props.requestedTerms || ''
        });
    }
    componentDidMount() {
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    setTermsText(event) {
        event.preventDefault();
        var value = event.target.value;
        this.setState({
            termsText: value
        })
    }
    handleSubmitRequest() {
        var termsText = this.state.termsText;
        this.setState({
            errorMessage: ''
        })
        if(termsText && termsText.trim()) {
            this.props.handleSubmitTermsRequest(termsText);
        } else {
            this.setState({
                errorMessage: 'Please enter the requested terms.'
            })
        }
    }
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="requestAdjustedTermsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Request Adjusted Terms</h2>
                    <p>To request adjusted terms on this order, please include the bulletin or customer program, the items that are eligible and the terms that need to be applied.</p>
                     <p className="bold">
                        Click SUBMIT REQUEST and then proceed to BOOK the order.
                    </p>
                    <p className="bold red">{this.state.errorMessage}</p>
                    <textarea id="requestAdjustedTermsTextfield" name="requestAdjustedTermsTextfield" style={{width: '100%', height: '150px'}} onChange={this.setTermsText.bind(this)} defaultValue={this.state.termsText} />
                    <div className="noButtonContainer">
                      	<a className="noButton blueButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
                    </div>
                    <div className="yesButtonContainer">
                      	<a className="yesButton blueButton" onClick={this.handleSubmitRequest.bind(this)}>Submit Request</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

RequestAdjustedTermsDialog = connect(mapStateToProps)(RequestAdjustedTermsDialog);
export default RequestAdjustedTermsDialog;


// WEBPACK FOOTER //
// ./src/App/components/dialogs/requestAdjustedTermsDialog.js